import { useCallback, useEffect, useState } from 'react'
import { useDispatch,useSelector } from 'react-redux'
import {
  downloadKnockOffExcel,
  getknockOffData,
} from '../api/provisionAdvanceApi'
import { DEFAULT_PAGE, getValidCriteria } from '../constants'
import { GLOBAL_CONSTANTS } from '../constants/globalConstants'
import {
  PROVISION_SEARCH_FIELDS,
} from '../constants/provision'
import { useFullScreen } from '../contexts/FullScreenContext'
import { useSnackbar } from '../contexts/SnackbarProvider'
import { fetchEntityListIfNeeded } from '../store/actions/entityTanActions'
import { ROLE_CAPABILITIES } from '../utils/role-capabilities.js'


export function useProvision() {
  const dispatch = useDispatch()
  const roleTypes = useSelector(state => state.user.role)
  const roleConfig = ROLE_CAPABILITIES[roleTypes] || ROLE_CAPABILITIES.default
  const defaultSearchCriteria = [
    {
      id: 1,
      logicalOperator: 'Where',
      field: PROVISION_SEARCH_FIELDS[0]?.id || '',
      value: '',
    },
  ]
  // States
  const [activeTabIndex, setActiveTabIndex] = useState(0)
  const { isFullScreen, toggleFullScreen, exitFullScreen } = useFullScreen()
  const [searchOpen, setSearchOpen] = useState(false)
  const [searchCriteria, setSearchCriteria] = useState(defaultSearchCriteria)
  const [anchorEl, setAnchorEl] = useState(null)
  const [totalItems, setTotalItems] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(100)
  const [tableData, setTableData] = useState([])
  const [loading, setLoading] = useState(true)
  const [expandedRows, setExpandedRows] = useState(new Set())
  const [showTable, setShowTable] = useState(false)
  const [selectedFilterData, setSelectedFilterData] = useState(null)
  const { showSnackbar } = useSnackbar()
  const [showExpandColumn,setShowExpendedColumn] = useState(true)

  // Variables + Constants
  const tabs = [
    { label: GLOBAL_CONSTANTS.PROVISIONS },
    { label: GLOBAL_CONSTANTS.ADVANCES },
  ]

  useEffect(() => {
    const payload = {
      pageFilter: {
        currentPage: 1,
        includeCount: true,
        pageSize: DEFAULT_PAGE,
        sortField: 'entityName',
        sortOrder: 'ASC',
      },
      requestFilter: [],
      isReportDownload: false,
      searchCOList: [],
    }
    if (roleConfig.canCreate) {
      dispatch(fetchEntityListIfNeeded(payload))
    }
  }, [dispatch,roleConfig.canCreate])
  
  const mapApiResponseToTableData = (apiData) => {
    return apiData.map((parent, parentIdx) => {
      const parentUuid = parent.vendorTransactionalDataUuid || `parent-${parentIdx}`;

      return {
        ...parent,
        uuid: parentUuid,
        referenceNumber: "-",
        isChild: false,
        hasChildren: parent.haveChildren,
        children: (parent.children || []).map((child, idx) => {
          const refNoParts = [];
          if (child.provisionAdjustmentRefNo) refNoParts.push(child.provisionAdjustmentRefNo);
          if (child.advanceAdjustmentRefNo) refNoParts.push(child.advanceAdjustmentRefNo);

          return {
            ...child,
            uuid: child.vendorTransactionalDataUuid || `${parentUuid}-child-${idx}`,
            parentId: parentUuid,
            isChild: true,
            referenceNumber: refNoParts.length > 0 ? refNoParts.join(" / ") : null,
          };
        }),
      };
    });
  };

  const fetchKnockOffTableData = async (
    currentPage,
    itemsPerPage,
    searchCOList,
    filterData,
    referencetype
  ) => {
    setLoading(true)
    const response = await getknockOffData(
      getPayload(
        currentPage,
        itemsPerPage,
        searchCOList,
        filterData,
        referencetype
      )
    )
    
    if (response?.success) {
        const tableData = mapApiResponseToTableData(response.data.content);       
        setExpandedRows(new Set())
        setTableData(tableData);
        setShowTable(true);
        setLoading(false)
        setTotalItems(response.data.totalElements)
    } else {
      showSnackbar(response?.error, 'error')
      setLoading(false)
    }

  }

  const downloadProvisionExcelFile = async (
    currentPage,
    itemsPerPage,
    searchCriteria,
    filterData,
    referencetype
  ) => {
    const result = await downloadKnockOffExcel(
      getPayload(
        currentPage,
        DEFAULT_PAGE,
        searchCriteria,
        filterData,
        referencetype
      )
    )
    if (result?.success && result?.data) showSnackbar(`Request Initiated for Download With Id: ${result.data.data}`, 'success')
      else if (result?.error) showSnackbar(result.error, 'error')
  
  }

  const getPayload = (currentPage, itemsPerPage, searchCOList,filterData,referencetype) => {
    const {tan,year,status} = filterData || selectedFilterData;
    return {
      pageFilter: {
        currentPage: currentPage,
        includeCount: true,
        pageSize: itemsPerPage,
        sortField: 'loadId',
        sortOrder: 'ASC',
      },
      searchCOList: getValidCriteria(searchCOList),
      entityTANs:[tan],
      financialYear:year,
      status:status,
      referenceType:referencetype
    }
  }

  const handleTabChange = index => {
    setActiveTabIndex(index)
    setSearchCriteria(defaultSearchCriteria)
    setShowTable(false)
  }

  const handleViewClick = filterData => {
    console.log(filterData,"filtwerdata");
    
    setSearchCriteria(defaultSearchCriteria)
    setSelectedFilterData(filterData)
    getCurrentTabData(
      currentPage,
      itemsPerPage,
      searchCriteria,
      filterData,
      activeTabIndex
    )
  }

  const getCurrentTabData = (
    currentPage,
    itemsPerPage,
    searchCriteria,
    filterData,
    index
  ) => {
    const referencetype = index === 0 ? 'Provision' : 'Advance'
    fetchKnockOffTableData(
        currentPage,
        itemsPerPage,
        searchCriteria,
        filterData,
        referencetype
      )
  }

  const handleFullscreen = useCallback(() => {
    toggleFullScreen()
  }, [])

  const handleFullScreenExit = useCallback(() => {
    exitFullScreen()
  }, [])

  const handleExcelDownload = () => {
    if(totalItems == 0){
      showSnackbar("No Data Found", 'info')
      return;
    }
    showSnackbar("Request Initiated","info");
    const referencetype = activeTabIndex === 0 ? 'Provision' : 'Advance'
     downloadProvisionExcelFile(
        currentPage,
        itemsPerPage,
        searchCriteria,
        selectedFilterData,
        referencetype
      )
  }

  const handleCloseSearch = () => {
    setSearchOpen(false)
    setAnchorEl(null)
  }

  const handleApplySearch = async searchList => {
    // Map fieldName to field for UI
    const mappedCriteria = searchList.map((item, idx) => ({
      ...item,
      field: item.fieldName || item.field || '',
      id: idx + 1,
      logicalOperator: item.logicalOperator || (idx === 0 ? 'Where' : 'And'),
    }))
    setSearchCriteria(mappedCriteria)
    setSearchOpen(false)
    getCurrentTabData(
      currentPage,
      itemsPerPage,
      searchList,
      selectedFilterData,
      activeTabIndex
    )
  }

  const handleResetSearch = async () => {
    setSearchCriteria(defaultSearchCriteria)
    setSearchOpen(false)
    getCurrentTabData(
      currentPage,
      itemsPerPage,
      defaultSearchCriteria,
      selectedFilterData,
      activeTabIndex
    )
  }

  const handleSearch = event => {
    setSearchOpen(!searchOpen)
    setAnchorEl(event.currentTarget)
  }

  const handlePageChange = page => {
    setCurrentPage(page)
  }

  const handleItemsPerPageChange = pageSize => {
    setItemsPerPage(pageSize)
    setCurrentPage(1)
  }

  const handleRowExpand = useCallback(rowId => {
    setExpandedRows(prev => {
      const newSet = new Set(prev)
      newSet.has(rowId) ? newSet.delete(rowId) : newSet.add(rowId)
      return newSet
    })
  }, [])

  return {
    tabs,
    activeTabIndex,
    isFullScreen,
    searchCriteria,
    anchorEl,
    searchOpen,
    totalItems,
    currentPage,
    itemsPerPage,
    tableData,
    loading,
    expandedRows,
    showTable,
    showExpandColumn,
    handleTabChange,
    handleViewClick,
    handleFullscreen,
    handleFullScreenExit,
    handleExcelDownload,
    handleSearch,
    handleCloseSearch,
    handleApplySearch,
    handleResetSearch,
    setSearchCriteria,
    handlePageChange,
    handleItemsPerPageChange,
    handleRowExpand,
  }
}
